
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors/create",
      function () {
        return require("private-next-pages/vendors/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors/create"])
      });
    }
  